/* eslint-disable @nx/enforce-module-boundaries */
import {
  Box,
  Button,
  HStack,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Select,
  Stack,
  Text,
} from '@mybridge/ui';
import { useContext, useEffect, useState } from 'react';
import { TeamsContext } from '../../context';
import { getUserFullName } from 'v4/lib/commons';
// import { useTranslator } from '../../../../mybridgeui/src/custom-hooks/useTranslation';
import { useTranslator } from '@mybridge/ui/custom-hooks/useTranslation';
import { useDirection } from '@mybridge/ui/custom-hooks/useDirection';


export const TeamDiskChangeDiskSubscriberModal = ({ onClose, title }) => {
  const {
    changeDiskSubscriberDisc,
    teamOrganizers,
    userProfileInfo,
    changeTeamDiskSubscriber,
    changeTeamDiskSubscriberLoading,
    cancelDiskSubscriptionChangeRequestLoading,
    cancelDiskSubscriptionChangeRequest,
  } = useContext(TeamsContext);
  const { t } = useTranslator();
    const direction = useDirection();
  
  const [user, setUser] = useState();
  const [users, setUsers] = useState();
  const [sent, setSent] = useState(false);
  const [response, setResponse] = useState();

  useEffect(() => {
    if (
      !teamOrganizers ||
      teamOrganizers.length <= 0 ||
      !userProfileInfo ||
      !userProfileInfo?.id
    )
      return;
    const users_ = teamOrganizers?.filter?.(
      (to) => to?.user?.id !== userProfileInfo?.id
    );
    if (!user) {
      setUser(users_?.[0]?.user);
    }
    setUsers(users_);
  }, [teamOrganizers, userProfileInfo]);

  const handleSubmit = async () => {
    if (user?.id) {
      const resp = await changeTeamDiskSubscriber({user: user});
      if (resp?.message?.includes('already sent')) {
        setSent(true);
        setResponse(resp);
      } else {
        setSent(false);
      }
    }
  };

  return (
    <Modal {...changeDiskSubscriberDisc}>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>
          {/* <Text>Change Subscriber</Text> */}
          <Text>{t('myDisk.changeSubscriber')||"Change Subscriber"}</Text>
          <ModalCloseButton {...(direction === 'rtl') ? {left: '0.75rem', right: 'auto'} : {left: 'auto', right: '0.75rem'}} />
        </ModalHeader>

        {sent ? (
          <>
            <ModalBody>
              <Text>
                {/* Request already sent to{' '} */}
                {t('myDisk.RequestAlreadySentTo')||"Request already sent to"}{' '}
                {getUserFullName(response?.request_id?.requested_to)}.
              </Text>
            </ModalBody>
            <ModalFooter>
              <HStack justifyContent="flex-end">
                <Button
                  variant="secondary"
                  isLoading={cancelDiskSubscriptionChangeRequestLoading}
                  onClick={(e) =>
                    cancelDiskSubscriptionChangeRequest?.(response?.request_id)
                  }
                >
                  {/* Cancel Request */}
                  {t('myDisk.CancelRequest')||"Cancel Request"}
                </Button>
              </HStack>
            </ModalFooter>
          </>
        ) : (
          ''
        )}

        {!sent ? (
          <>
            <ModalBody>
              <Select
                borderRadius="20px"

                defaultValue={users?.[0]?.user?.id}
                onChange={(e) => {
                  const id = e?.target?.value;

                  setUser(users?.find?.((u) => u?.user?.id == id));
                }}
              >
                {users?.map?.((to, toIndex) => (
                  <option key={to?.user?.id} value={to?.user?.id}>
                    {getUserFullName(to?.user)}
                  </option>
                ))}
              </Select>
            </ModalBody>
            <ModalFooter>
              <HStack justifyContent="flex-end">
                <Button
                borderRadius="20px"
                  variant="secondary"
                  onClick={(e) => changeDiskSubscriberDisc?.onClose?.()}
                >
                  {/* Cancel */}
                  {t('myDisk.Cancel')||"Cancel"}
                </Button>

                <Button
                borderRadius="20px"

                  isLoading={changeTeamDiskSubscriberLoading}
                  variant="primary"
                  onClick={handleSubmit}
                >
                  {/* Send Request */}
                  {t("myDisk.sendRequest")||"Send Request"}
                </Button>
              </HStack>
            </ModalFooter>
          </>
        ) : (
          ''
        )}
      </ModalContent>
    </Modal>
  );
};
